var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 86.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,84.36V11.28L8.16,0V84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.36,23.52a23.76,23.76,0,0,1-2,9.6L48.12,84.36h-9L55.8,45.84a22.85,22.85,0,0,1-6.48.84,23.1,23.1,0,1,1,23-23.16Zm-8.4,0A14.7,14.7,0,1,0,49.32,38.28,14.72,14.72,0,0,0,64,23.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.36,84.36l18-41.28c2.52-5.64,3.12-8.64,3.12-11.64,0-12.24-10.2-22.2-21.72-22.2h-.6V1.08h.6c16.08,0,29.88,13.56,29.88,30.36,0,4.2-.84,8.28-3.6,14.52L96.84,76.2h22.08v8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.36,43.32A42.84,42.84,0,1,1,172.19,86,42.86,42.86,0,0,1,129.36,43.32Zm77.15,0a34.32,34.32,0,1,0-34.32,34.32A34.42,34.42,0,0,0,206.51,43.32Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.f0a4a3db049fd23d3b4b4f77bcfe7c1f.svg";
export { ForwardRef as ReactComponent };